import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src'
import { RegisterExtras } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'

@Component({
  selector: 'gb-register-dialog',
  templateUrl: './gb-register-dialog.component.html',
  styleUrls: ['./gb-register-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbRegisterDialogComponent {
  @Input() registerExtras?: RegisterExtras
  displaySocialLogin$ = this.auctionFacade.displaySocialLogin$
  isVolunteer$ = this.authFacade.isVolunteer$

  constructor(private auctionFacade: AuctionFacade, private authFacade: AuthFacade) {}
}
